import React, { FC } from "react";
import { Link } from "react-router-dom";
import { slugify } from "../../util/slugify";

interface ArticleLinkProps {
  title: string;
  id: number;
  className?: string; // Optional className prop
}

const ArticleLink: FC<ArticleLinkProps> = ({ title, id, className }) => {
  const slug = slugify(title);
  const articleUrl = `/article/${slug}/${id}`;

  return (
    <Link className={className} to={articleUrl}>
      {title}
    </Link>
  );
};

export default ArticleLink;
